import React from "react";

const CancelButton = ({ onCancel }) => {
  return (
    <div className="widget-news-footer one-column">
      <div onClick={onCancel} style={{ cursor: "pointer" }}>
        <strong>Cancel Invitation</strong>
      </div>
    </div>
  );
};

export default CancelButton;



// WEBPACK FOOTER //
// ./src/_components/UI/UserWidget/CancelButton/index.js